import React from 'react';
import Immutable from 'immutable'




export const SelectionModes = {
    TOGGLE:'TOGGLE', // click toggles selection
    MULTI_SELECT:'MULTI_SELECT', // click select all visible items from last item clicked
    MULTI_DESELECT:'MULTI_DESELECT', //click deselects all visible items from last item clicked
};

export const SelectionStates = {
    ENABLED:'ENABLED', // fully active
    VISIBLE:'VISIBLE', // only showing
    DISABLED:'DISABLED', // well...
};

const DEFAULT_TYPE = Symbol('DEFAULT_TYPE'); // if no item type is specified this is used..

export const isSelectionVisible = (state) => state === SelectionStates.ENABLED || state ===SelectionStates.VISIBLE;




class SelectionManager extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            selectionMode:SelectionModes.TOGGLE,
            selectedItems:Immutable.Set(),
            lastItemClicked:{},
        };
        this.itemOrder = {};

        this.recordOrder = this.recordOrder.bind(this);
        this.handleClick = this.handleClick.bind(this);
        this.updateSelectionMode = this.updateSelectionMode.bind(this);
    }
    componentDidMount() {

        // Listen to modifiers so we know in what mode to operate
        window.addEventListener("keyup", this.updateSelectionMode);
        window.addEventListener("keydown", this.updateSelectionMode);
    }

    componentWillUnmount() {

        window.removeEventListener("keydown", this.updateSelectionMode);
        window.removeEventListener("keyup", this.updateSelectionMode);
    }

    updateSelectionMode(event) {
        // SHIFT will select from last clicked item
        // CMD+SHIFT will unselect from last clicked item

        let selectionMode = !event.shiftKey?SelectionModes.TOGGLE:(event.metaKey? SelectionModes.MULTI_DESELECT: SelectionModes.MULTI_SELECT);
        if(this.props.selectionState===SelectionStates.ENABLED && this.state.selectionMode !== selectionMode) {
            this.setState({selectionMode : selectionMode});
        }
    }

    componentWillReceiveProps(nextProps) {
        // TODO: If items has changed, remove non existent items from selectedItems
        //
    }

    // This "records" which order items get rendered
    recordOrder(item, type=DEFAULT_TYPE) {
        let orderList = this.itemOrder[type];
        if( !orderList ) {
            orderList = [];
            this.itemOrder[type] = orderList;
        }
        orderList.push(item);
    }

    multiSelect(start, end, select, orderList) {
        if ( end<start) {
            [start,  end] = [end,  start];
        }
        let selectedItems = this.state.selectedItems;

        for (let i = start; i<= end; i++) {

            selectedItems = select?selectedItems.add(orderList[i]):selectedItems.remove(orderList[i]);
        }
        return selectedItems;
    }
    handleClick(item, type = DEFAULT_TYPE) {
        if(this.props.selectionState !== SelectionStates.ENABLED) {
            this.props.handleClick(item, type);
            return;
        }
        let {selectionMode, selectedItems } = this.state;
        let orderList = this.itemOrder[type];
        console.dir(orderList);
        if( !orderList) {
            console.warn("No selection info for items of type "+type);
            return;
        }

        let currentIndex = orderList.indexOf(item);

        // recalculate last index in case our items order has changed
        let lastIndex = orderList.indexOf(this.state.lastItemClicked);
        if ( lastIndex < 0 ) {
            // If our last item is not visible anymore, "disable" region selection
            lastIndex = currentIndex;
        }
        let selectedItems2 = selectedItems;
        switch (selectionMode) {
            case SelectionModes.TOGGLE:
                if (this.state.selectedItems.contains(item)) {

                    selectedItems2 = selectedItems.remove(item);
                } else {
                    selectedItems2 = selectedItems.add(item);
                }
                break;
            case SelectionModes.MULTI_SELECT:
                selectedItems2 = this.multiSelect(lastIndex, currentIndex, true, orderList);
                break;
            default:
                // MULTI_DESELECT
                selectedItems2 = this.multiSelect(lastIndex, currentIndex, false, orderList);
                break;
        }
        this.setState({ lastItemClicked:item,  lastIndexClicked:currentIndex, selectedItems: selectedItems2});
        this.props.handleSelection(selectedItems2);
    }
    render() {
        this.itemOrder = {};
        if ( React.Children.count(this.props.children)===1) {
            const MyElement = this.props.children;
            const selectionInfo  = {
                state:this.props.selectionState, // ENABLED, VISIBLE, DISABLED
                mode:this.state.selectionMode,
                recordOrder:this.recordOrder,
                handleClick:this.handleClick,
                selectedItems:this.state.selectedItems,
                lastItemClicked:this.state.lastItemClicked,
            }
            return (React.cloneElement(MyElement, {
                selectionInfo:selectionInfo
            }));
        }
        else
            return(<div>{this.props.children}</div>)
    }
}
SelectionManager.propTypes = {
    handleSelection:React.PropTypes.func.isRequired,
    handleClick:React.PropTypes.func.isRequired,
    selectionState:React.PropTypes.string.isRequired,
};

export default SelectionManager;


// WEBPACK FOOTER //
// ./src/ui/components/editor/SelectionManager.js